export const MerchantSelectionViewReferenceCodeStyles = {
  container: (marginBottom: boolean = false) =>
    `w-full flex py-3 px-6 flex-col text-center bg-white ${marginBottom ? 'mb-3' : ''}`,
  label: 'text-blue700 text-20px mt-2',
  referenceCode: 'text-blue300 font-bold text-28px',
}
